<template>
  <div class="update-meeting-page" v-if="meeting">
    <div @click="$router.push({name: 'meetings.show', params: {id: meeting.id}})" class="back-btn cursor-pointer">
      <img src="../../assets/icon/arrow-left.png" class="h-12 w-12" alt="">
      <span class="">編集をキャンセル</span>
    </div>
    <UpdateMedicationInstruction v-if="meeting.is_reservation" :meeting="meeting"/>
    <UpdateOnline v-else :meeting="meeting"/>
  </div>
</template>

<script>
import moment from 'moment'
import MeetingsApi from '@/api/meeting'
import {convert2LocalTime, apiErrorDialog} from '@/helpers'
import UpdateOnline from '@/pages/Meeting/Online/Update'
import UpdateMedicationInstruction from '@/pages/Meeting/MedicationInstruction/Update'

export default {
  components: {
    UpdateOnline,
    UpdateMedicationInstruction
  },
  data () {
    return {
      meeting: null
    }
  },
  methods: {
    async fetchMeeting () {
      const meetingID = this.$route.params.id
      const res = await MeetingsApi.getById(meetingID)
        .catch((error) => {
          apiErrorDialog(this, error)
        })
      const meeting = res.data.data
      this.meeting = {
        id: meeting.id,
        is_reservation: meeting.is_reservation,
        title: meeting.title,
        time_picked: meeting.time_picked
      }
      if (this.meeting.is_reservation) {
        this.meeting = {
          ...this.meeting,
          category: meeting.category,
          pharmacy: meeting.pharmacy,
          start_at: meeting.start_at,
          end_at: meeting.end_at,
          time: {start: null, end: null}
        }
      } else {
        this.meeting = {
          ...this.meeting,
          category: meeting.category.id,
          selectedUsers: [],
          start_at: meeting.start_at,
          end_at: meeting.end_at,
          time: {start: null, end: null, dayInWeek: null},
          participants: meeting.participants
        }
      }

      const localTime = moment.tz.guess()
      this.meeting.start_at = convert2LocalTime(this.meeting.start_at, localTime)
      this.meeting.end_at = convert2LocalTime(this.meeting.end_at, localTime)
    }
  },
  mounted () {
    this.fetchMeeting()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Meeting/Edit.vue